import type { MemeRegistry } from '../config/memes/types';

/**
 * Pick a random meme URL for a question from the registry.
 * 1. Prefer memes whose potentialQuestions include the questionId.
 * 2. If none, use memes with topic 'generic' as fallback.
 * Returns null if no meme is available.
 */
export function getMemeUrlForQuestion(
  questionId: string,
  registry: MemeRegistry
): string | null {
  const forQuestion = registry.filter((e) =>
    e.potentialQuestions.includes(questionId)
  );
  if (forQuestion.length > 0) {
    const entry = forQuestion[Math.floor(Math.random() * forQuestion.length)];
    return entry.imageUrl;
  }
  const generic = registry.filter((e) => e.topics.includes('generic'));
  if (generic.length > 0) {
    const entry = generic[Math.floor(Math.random() * generic.length)];
    return entry.imageUrl;
  }
  return null;
}
